import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import SmartFeedLayout from "~/dynamic-components/options/smart-feed-layout";
import ShowDots from "%/dynamic-components/render-engine/options/carousel/show-dots";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import EmptyStateText from "%/dynamic-components/render-engine/options/empty-state-text";
import SmartFeedPagination from "~/dynamic-components/options/smart-feed-pagination";
import SmartFeedPageLimit from "~/dynamic-components/options/smart-feed-page-limit";
import SmartFeedSeeAllDestination from "~/dynamic-components/options/smart-feed-see-all-destination";
import SmartFeedSeeMoreText from "~/dynamic-components/options/smart-feed-see-more-text";
import SmartFeedSeeAllText from "~/dynamic-components/options/smart-feed-see-all-text";
import SmartFeedSeeMoreAlignment from "~/dynamic-components/options/smart-feed-see-more-alignment";
import SmartFeedColumnMinWidth from "~/dynamic-components/options/smart-feed-column-min-width";
import SmartFeedColumnMaxWidth from "~/dynamic-components/options/smart-feed-column-max-width";
import AppFeedComponent from "~/dynamic-components/options/app-feed-component";

export default class AppFeedOptions extends BaseOptionsBundle {

  optionTitle = "Feed Options";
  static optionClassName = "i-dynamic-global-feed-bundle";

  inspectorToolGroup = "app-feed";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.GLOBAL_FEED_TOOL_SET,
  };

  constructor(values = {}) {

    super(values, [
      AppFeedComponent,
      SmartFeedLayout,
      new ShowDots({ "default": true }), // existing carousels keep their dots
      SmartFeedPagination,
      SmartFeedPageLimit,
      SmartFeedSeeAllDestination,
      SmartFeedSeeMoreText,
      SmartFeedSeeMoreAlignment,
      SmartFeedSeeAllText,
      SmartFeedColumnMinWidth,
      SmartFeedColumnMaxWidth,
      new EmptyStateText({ "default": "No results found." }),
    ]);
  }
}
